import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import { dashedBorderCssStyle } from '../../../../../views/indexing/components/ui/Draggable'

export const droppableContainerCss = css`
  border-radius: 4px;
`

export const activeBorderCss = css`
  ${droppableContainerCss};
  outline: solid 4px ${colors.blue10};
  outline-offset: 4px;
`

export const dashedDropTargetCss = css`
  ${dashedBorderCssStyle};
  border-radius: 4px;
`

export const dashedDropTargetActiveCss = css`
  ${dashedDropTargetCss};
  background-color: ${colors.blue03};
`
